var map = {
	"./aq.svg": "STwS",
	"./lhy.svg": "KGJK",
	"./sd.svg": "Kq7J",
	"./wd.svg": "+kNx",
	"./wx.svg": "jdH6",
	"./xuanjian.svg": "OxtA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F2k2";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiles ^\.\/.*$
// module id = F2k2
// module chunks = 1